//Frontend Enum
export enum VersionType {
  Draft = 0,
  Public = 1,
  Prepublication = 2,
  Archive = 3
}
